import ArrowButton from '@/components/molecules/arrowButton'
import MahimaIcon from '@/components/atoms/mahimaIcon'
import ButtonGroup from './buttonGroup'
import LinkGroup from './linkGroup'
import Address from './address'
import { PortableText } from 'next-sanity'
import editorRule from '@/components/atoms/editorRule'
import { useMediaQuery } from '@mui/material'

const Footer = ({ footerAPI }) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  return (
    <footer className="relative w-full px-[25px] py-[50px] lg:p-mediumDesktop bg-olive">
      <div className="relative w-full max-w-1440 mx-auto flex flex-col lg:flex-row justify-between gap-x-[50px]">
        <div className="flex flex-col lg:justify-between">
          <MahimaIcon />
          <ButtonGroup
            bookFacilitiesLink={footerAPI.bookFacilitiesLink}
            membershipLink={footerAPI.membershipLink}
          />
        </div>
        <div className="flex flex-col gap-y-[50px] lg:gap-y-[80px] mt-[50px] lg:mt-0">
          <div className="flex flex-col lg:flex-row gap-[17px] lg:gap-[130px]">
            <span className="w-[200px] text-subheadingCardsMobile md:text-subheadingCardsDesktop text-background font-chivoMono">
              GET IN TOUCH
            </span>
            {isDesktop && <Address text={footerAPI.address} />}
            {!isDesktop && <LinkGroup contact={footerAPI.contact} />}
          </div>
          <div className="flex flex-col lg:flex-row gap-[24px] lg:gap-[130px]">
            {isDesktop && <LinkGroup contact={footerAPI.contact} />}
            {!isDesktop && <Address text={footerAPI.address} />}
            <div className="flex flex-col gap-y-[50px] lg:gap-y-[52px]">
              <ArrowButton
                name="MAP"
                link={footerAPI.mapLink}
                target="_blank"
                color="secondary"
              />
              <div className="content relative w-full text-bodyMobile md:text-bodyDesktop font-chivoMono text-background">
                <PortableText
                  value={footerAPI.operationalHours}
                  components={editorRule()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
